export default {
  solicitacoes: [],
  totalSolicitacoes: 0,
  filter: null,
  files: [],
  historics: [],
  reasons: [],
  empreendimentos: [],
  empreendimentosUser: [],
  services: [],
  status: 'Todos',
  clicked: 1,
  pagination: {
    pageCount: 1,
    totalItemCount: 1,
    pageNumber: 1,
    pageSize: 1
  },
  altCancPagination: {
    pageCount: 1,
    totalItemCount: 1,
    pageNumber: 1,
    pageSize: 1
  },
  showDeadline: false,
  numeroIdDiretriz: '',
  addressHistoric: [],
  filesHasChanges: false,
  hasAltCancelAproveGrant: false,
  pendingAltCancelHists: [],
  pendingAltCancCommentDetails: {},
  isPendingRequestAltCanc: false
}
